import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Navigation from './Navigation';
import Footer from './Footer';
const PrivacyContent: React.FC = () => {
  const { language } = useLanguage();

  const privacyContent = {
    fr: {
      title: 'Politique de Confidentialité',
      lastUpdated: 'Dernière mise à jour : 2026',
      sections: [
        {
          title: '1. Introduction',
          content: 'Sparkr (« nous », « notre » ou « nos ») s\'engage à protéger votre vie privée. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles lorsque vous visitez notre site web.',
        },
        {
          title: '2. Informations que nous collectons',
          content: 'Nous collectons les informations que vous nous fournissez directement, notamment lorsque vous nous contactez par e-mail. Ces informations peuvent inclure votre nom, votre adresse e-mail et tout autre contenu que vous choisissez de partager avec nous.',
        },
        {
          title: '3. Utilisation des informations',
          content: 'Nous utilisons les informations collectées pour répondre à vos demandes, améliorer nos services et communiquer avec vous concernant nos services. Nous ne vendons ni ne louons vos informations personnelles à des tiers.',
        },
        {
          title: '4. Protection des données',
          content: 'Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos informations personnelles contre tout accès non autorisé, altération, divulgation ou destruction.',
        },
        {
          title: '5. Vos droits',
          content: 'Vous avez le droit d\'accéder, de modifier ou de supprimer vos informations personnelles à tout moment. Pour exercer ces droits, veuillez nous contacter à contact@sparkr.tech.',
        },
        {
          title: '6. Cookies',
          content: 'Notre site web peut utiliser des cookies pour améliorer votre expérience de navigation. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter certaines fonctionnalités du site.',
        },
        {
          title: '7. Modifications de cette politique',
          content: 'Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page avec une date de mise à jour révisée.',
        },
        {
          title: '8. Contact',
          content: 'Pour toute question concernant cette politique de confidentialité, veuillez nous contacter à contact@sparkr.tech.',
        },
      ],
    },
    en: {
      title: 'Privacy Policy',
      lastUpdated: 'Last updated: 2026',
      sections: [
        {
          title: '1. Introduction',
          content: 'Sparkr ("we", "our", or "us") is committed to protecting your privacy. This privacy policy explains how we collect, use, and protect your personal information when you visit our website.',
        },
        {
          title: '2. Information We Collect',
          content: 'We collect information that you provide directly to us, including when you contact us via email. This information may include your name, email address, and any other content you choose to share with us.',
        },
        {
          title: '3. Use of Information',
          content: 'We use the collected information to respond to your inquiries, improve our services, and communicate with you regarding our services. We do not sell or rent your personal information to third parties.',
        },
        {
          title: '4. Data Protection',
          content: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.',
        },
        {
          title: '5. Your Rights',
          content: 'You have the right to access, modify, or delete your personal information at any time. To exercise these rights, please contact us at contact@sparkr.tech.',
        },
        {
          title: '6. Cookies',
          content: 'Our website may use cookies to enhance your browsing experience. You can configure your browser to refuse cookies, but this may affect some site functionality.',
        },
        {
          title: '7. Changes to This Policy',
          content: 'We reserve the right to modify this privacy policy at any time. Changes will be posted on this page with a revised update date.',
        },
        {
          title: '8. Contact',
          content: 'For any questions regarding this privacy policy, please contact us at contact@sparkr.tech.',
        },
      ],
    },
    es: {
      title: 'Política de Privacidad',
      lastUpdated: 'Última actualización: 2026',
      sections: [
        {
          title: '1. Introducción',
          content: 'Sparkr (« nosotros », « nuestro » o « nuestros ») se compromete a proteger su privacidad. Esta política de privacidad explica cómo recopilamos, utilizamos y protegemos su información personal cuando visita nuestro sitio web.',
        },
        {
          title: '2. Información que recopilamos',
          content: 'Recopilamos la información que nos proporciona directamente, incluso cuando nos contacta por correo electrónico. Esta información puede incluir su nombre, dirección de correo electrónico y cualquier otro contenido que elija compartir con nosotros.',
        },
        {
          title: '3. Uso de la información',
          content: 'Utilizamos la información recopilada para responder a sus consultas, mejorar nuestros servicios y comunicarnos con usted sobre nuestros servicios. No vendemos ni alquilamos su información personal a terceros.',
        },
        {
          title: '4. Protección de datos',
          content: 'Implementamos medidas de seguridad apropiadas para proteger su información personal contra el acceso no autorizado, alteración, divulgación o destrucción.',
        },
        {
          title: '5. Sus derechos',
          content: 'Tiene derecho a acceder, modificar o eliminar su información personal en cualquier momento. Para ejercer estos derechos, contáctenos en contact@sparkr.tech.',
        },
        {
          title: '6. Cookies',
          content: 'Nuestro sitio web puede usar cookies para mejorar su experiencia de navegación. Puede configurar su navegador para rechazar cookies, pero esto puede afectar algunas funcionalidades del sitio.',
        },
        {
          title: '7. Cambios en esta política',
          content: 'Nos reservamos el derecho de modificar esta política de privacidad en cualquier momento. Los cambios se publicarán en esta página con una fecha de actualización revisada.',
        },
        {
          title: '8. Contacto',
          content: 'Para cualquier pregunta sobre esta política de privacidad, contáctenos en contact@sparkr.tech.',
        },
      ],
    },
  };

  const content = privacyContent[language];

  return (
    <div className="App">
      <Navigation />
      <main className="legal-page">
        <div className="container">
          <div className="legal-content">
            <h1 className="legal-title">{content.title}</h1>
            <p className="legal-updated">{content.lastUpdated}</p>
            {content.sections.map((section, index) => (
              <section key={index} className="legal-section">
                <h2 className="legal-section-title">{section.title}</h2>
                <p className="legal-section-content">{section.content}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

const Privacy: React.FC = () => {
  return <PrivacyContent />;
};

export default Privacy;

